import React from "react";
import login from "../assets/project1/login.png";
import adddoctor from "../assets/project1/adddoctor.png";
import agendar from "../assets/project1/agendar.png";
import citas from "../assets/project1/citas.png";

const Project = ({ lenguaje }) => {
  const hideProject = () => {
    document.querySelector(".projectPopUp").style.setProperty("opacity", "0");

    document.querySelector(".projectPopUp").style.setProperty("z-index", "0");
  };

  return (
    <div className="projectPopUp">
      <h1>
        {lenguaje == "eng"
          ? "Hospital Management"
          : "Administrador de Hospital"}
      </h1>
      <div className="imagenes">
        <img src={login} alt="" />
        <img src={adddoctor} alt="" />
        <img src={agendar} alt="" />
        <img src={citas} alt="" />
      </div>

      <button id="close" onClick={() => hideProject()}>
        {lenguaje == "eng" ? "Close" : "Cerrar"}
      </button>
    </div>
  );
};

export default Project;
